import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createBlock as _createBlock, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "bi-tmpl-detail__right__cmpt" }
const _hoisted_2 = {
  key: 0,
  class: "bi-tmpl-detail__right__cmpt__tips"
}

import PcModuleSurvey from '@V/bi-tmpl/src/components/bi-pc-module/pc-module-survey';

import { BaseRadio } from 'xrk-components';
import { BaseCard } from 'xrk-components';
import { useDetailCmpt } from '@V/bi-tmpl/src/hooks';
import { Carousel } from '@/components/base/carousel';
const CHILD_KEY = '5_1';

export default /*#__PURE__*/_defineComponent({
  __name: 'bi-tmpl-detail-5-1',
  setup(__props) {

const TYPE_MAPPING = [1, 2, 3, 4, 5, 6].map(i => {
  return {
    value: 'pc-module-survey-' + i,
    index: i
  };
});

const getStyle: any = index => {
  if (index < 4) {
    return {
      transform: 'scale(0.45) translateY(-600px)',
      transformOrigin: 'center center',
      width: '1024px',
      height: '488px',
      position: 'relative'
    };
  } else {
    return {
      width: '400px',
      margin: '-70px 0 0'
    };
  }
};

const { curItem, onChange } = useDetailCmpt({ childKey: CHILD_KEY });
const cmpName = name => {
  return PcModuleSurvey.filter(comp => comp.__name === name)[0];
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      (_unref(curItem).tips)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_unref(curItem).tips), 1))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_unref(Carousel), {
      ref: "carouselRef",
      itemHeight: 200,
      itemWidth: 420 + 56
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(TYPE_MAPPING), (item, index) => {
          return (_openBlock(), _createElementBlock("div", { key: index }, [
            _createVNode(_unref(BaseCard), { style: {"width":"420px","height":"200px"} }, {
              default: _withCtx(() => [
                _createVNode(_unref(BaseRadio), {
                  class: "bi-tmpl-detail__right__cmpt__radio bi-tmpl-detail__right__cmpt__radio--w",
                  style: {"bottom":"-90px"},
                  value: item.value,
                  "model-value": _unref(curItem).value,
                  onClick: ($event: any) => (_unref(onChange)(item.value))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      style: _normalizeStyle(getStyle(index))
                    }, [
                      (_openBlock(), _createBlock(_resolveDynamicComponent(cmpName(item.value)), _mergeProps({ ref_for: true }, {
                  optionData: {
                    topicSum: 2, //多少题
                    isShowUserSum: 1,
                    userSum: 1,
                    analysisDimen: '主体分析'
                  }
                }), null, 16))
                    ], 4)
                  ]),
                  _: 2
                }, 1032, ["value", "model-value", "onClick"])
              ]),
              _: 2
            }, 1024)
          ]))
        }), 128))
      ]),
      _: 1
    }, 512)
  ]))
}
}

})